import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

/**
 * Service d'authentification
 */
@Injectable({
  providedIn: 'root'
})
export class AuthentificationService {

    private subject = new Subject<any>();

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Indique si l'utilisateur est connect�
     */
    estConnecte() {
        return this.http.get(`api/account/islogged`).pipe(map(retour => {
            return retour === true;
        }));
    }

    /**
     * Connecter l'utilisateur
     * @param login
     * @param motDePasse
     * @param persisterConnexion
     */
    connexion(login: string, motDePasse: string, persisterConnexion: boolean) {
        let logonModel = {
            Login: login,
            Password: motDePasse,
            RememberMe: persisterConnexion
        };
        return this.http.post<any>(`api/account/logon`, logonModel).pipe(map(retour => { if (retour && retour.Result === true) { this.envoyerEstConnecte(true); } return retour; }));
    }

    /**
     * D�connecter l'utilisateur'
     */
    deconnexion() {
        return this.http.get(`api/account/logout`).pipe(map(retour => {
            return retour;
        }));
    }

    /**
     * R�initialiser le mot de passe
     * @param login
     */
    reinitialiserMotDePasse(login: string) {
        let model = {
            Login: login
        };
        return this.http.post<any>(`api/account/resetpassword`, model).pipe(map(retour => { return retour; }));
    }

    /**
     * Envoyer l'information indiquant si l'utilisateur est connect�
     * @param estConnecte
     */
    private envoyerEstConnecte(estConnecte: boolean) {
        this.subject.next(estConnecte);
    }

    /**
     * Obtenir l'information indiquant que l'utilisateur est connect�
     */
    public obtenirEstConnecte(): Observable<any> {
        return this.subject.asObservable();
    }

    /**
     * Commencer l'usurpation
     * @param login
     */
    commencerUsurpation(login: string, code: string) {
        let model = {
            Login: login,
            Code: code
        };
        return this.http.post<any>(`api/account/commencerusurpation`, model).pipe(map(retour => { return retour; }));
    }

    /**
     * Terminer l'usurpation
     */
    terminerUsurpation(): any {
        return this.http.get(`api/account/terminerusurpation`).pipe(map(retour => { return retour; }));
    }

    /**
     * Indique si l'utilisateur poss�de le r�le
     */
    possedeRole(role: string): Observable<boolean> {
        let httpParams = new HttpParams().set('Role', role);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/account/hasrole`, options).pipe(map(retour => { return retour === true; }));
    }
}
